import { httpsCallable } from "firebase/functions";
import { functions } from "../../config/firebase";

const isGoogleConnectionEnabled =
  process.env.REACT_APP_ENABLE_GOOGLE_CONNECTION === "true";
const isZoomConnectionEnabled =
  process.env.REACT_APP_ENABLE_ZOOM_CONNECTION === "true";

const getPublicSlots = async ({ userId, from, to, timezone }) => {
  const callable = httpsCallable(functions, "getPublicSlots");
  const response = await callable({ userId, from, to, timezone });
  return response.data;
};

const createPublicBooking = async ({
  userId,
  startAt,
  durationMinutes,
  timezone,
  inviteeName,
  inviteeEmail,
  notes,
}) => {
  const callable = httpsCallable(functions, "createPublicBooking");
  const response = await callable({
    userId,
    startAt,
    durationMinutes,
    timezone,
    inviteeName,
    inviteeEmail,
    notes,
  });
  return response.data;
};

const startGoogleOAuth = async ({ redirectUrl }) => {
  if (!isGoogleConnectionEnabled) {
    return { disabled: true };
  }
  const callable = httpsCallable(functions, "googleOAuthStart");
  const response = await callable({ redirectUrl });
  return response.data;
};

const startZoomOAuth = async ({ redirectUrl }) => {
  if (!isZoomConnectionEnabled) {
    return { disabled: true };
  }
  const callable = httpsCallable(functions, "zoomOAuthStart");
  const response = await callable({ redirectUrl });
  return response.data;
};

const getGoogleConnectionStatus = async () => {
  if (!isGoogleConnectionEnabled) {
    return {
      providerConnected: false,
      providerEmail: "",
      disabled: true,
    };
  }
  const callable = httpsCallable(functions, "getGoogleConnectionStatus");
  const response = await callable();
  return response.data;
};

const getZoomConnectionStatus = async () => {
  if (!isZoomConnectionEnabled) {
    return {
      providerConnected: false,
      providerEmail: "",
      disabled: true,
    };
  }
  const callable = httpsCallable(functions, "getZoomConnectionStatus");
  const response = await callable();
  return response.data;
};

const bookingFunctionsService = {
  getPublicSlots,
  createPublicBooking,
  startGoogleOAuth,
  startZoomOAuth,
  getGoogleConnectionStatus,
  getZoomConnectionStatus,
};

export default bookingFunctionsService;
